import { isPrimaryApplicant } from '../../../helpers/applicationHelp';

export const SetActiveFeature = ({
  properties,
  isPropertyInSection,
  features,
  sections,
  activeIndex,
  setOwners,
  setData,
  isEdit,
  removeCreateForm,
  setIsShowCreateForm,
  appDataRef,
}) => {
  const activeProperties = properties.filter((property) =>
    isPropertyInSection(features, sections[activeIndex.sectionIndex], property)
  );
  const activeFeature = features.find(
    (item) => item.name === activeProperties[activeIndex.propertyIndex]
  );

  if (
    activeFeature?.itemType === 'ApplicantProperty' &&
    (isEdit || !isPrimaryApplicant(appDataRef.current))
  ) {
    removeCreateForm();
  } else if (activeFeature?.itemType === 'LicenseProperty') {
    removeCreateForm();
  } else {
    setIsShowCreateForm(true);
  }

  if (activeFeature?.value) {
    if (activeFeature.itemType === 'ApplicantProperty' && Array.isArray(activeFeature.value)) {
      const ownersArray = [...activeFeature.value];
      if (isEdit || !isPrimaryApplicant(appDataRef.current)) {
        setOwners(
          ownersArray.map((ownerItem) => {
            return {
              ...ownerItem,
              address: ownerItem.address
                ? {
                    ...ownerItem.address,
                    label: ownerItem.address.deliveryLine1,
                  }
                : null,
            };
          })
        );
      } else {
        if (!ownersArray.length) return;
        let popped = ownersArray.pop();
        setData({
          ...popped,
          address: popped.address
            ? { ...popped.address, label: popped.address.deliveryLine1 }
            : null,
        });
        setOwners(
          ownersArray.map((ownerItem) => {
            return {
              ...ownerItem,
              address: ownerItem.address
                ? {
                    ...ownerItem.address,
                    label: ownerItem.address.deliveryLine1,
                  }
                : null,
            };
          })
        );
      }
    } else if (activeFeature.itemType === 'FileProperty' && Array.isArray(activeFeature.value)) {
      let fileData = {};
      const originalFileTypes = Object.keys(activeFeature.format);
      activeFeature.value
        .filter((field) => !field.fileType.includes('bankVerificationStatement'))
        .map((item) => {
          if (originalFileTypes.includes(item['fileType'])) {
            // For the fields that exist under feature.format
            if (item['category']) {
              if (!fileData[item['fileType']]) {
                fileData[item['fileType']] = [];
              }
              fileData[item['fileType']].push({
                ...item,
                isProtected: item.password == 'masked' ? '1' : '0',
                password: null,
                isPwdShow: '0',
              });
            } else {
              if (!fileData[item['fileType']]) {
                fileData[item['fileType']] = [];
              }
              fileData[item['fileType']].push({
                ...item,
                isProtected: item.password == 'masked' ? '1' : '0',
                password: null,
                isPwdShow: '0',
              });
            }
          } else {
            // For the fields that only exist under feature.value
            fileData[item['fileName']] = [
              {
                ...item,
                isProtected: item.password == 'masked' ? '1' : '0',
                password: null,
                isPwdShow: '0',
              },
            ];
          }
        });
      setData(fileData);
    } else {
      const d = activeFeature.value;

      setData({
        ...d,
        address: d.address ? { ...d.address, label: d.address.deliveryLine1 } : null,
      });
    }
  } else {
    setData({
      address: null,
    });
  }
};
